(function () {
  function setup() {
    var wrapper = document.querySelector(
      ".collection-wrapper_drower .facets__sort-wrapper",
    );
    if (!wrapper) return;

    var parent = wrapper.closest(".collection-wrapper_drower");
    if (!parent) return;

    function update() {
      var h = wrapper.offsetHeight;
      parent.style.setProperty("--sort-wrapper-height", h + 24 + "px");
    }

    new ResizeObserver(update).observe(wrapper);
    update();
  }

  setup();

  // Re-setup after AJAX filter changes replace the DOM
  var container = document.querySelector(".collection-wrapper_drower");
  if (container) {
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(setup, 100);
    }).observe(container, { childList: true, subtree: true });
  }
})();
